import React, { useState, } from 'react';
import { connect, } from 'react-redux';
import Link from '@material-ui/core/Link';
import AppBar from '@material-ui/core/AppBar';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import MenuIcon from '@material-ui/icons/Menu';
import Hidden from '@material-ui/core/Hidden';
import Box from '@material-ui/core/Box';

import { layout, } from 'styles';
import { UserPanelContainer, } from './components/UserPanel';
import logo from 'assets/images/logo_gwo.svg';
import Drawer from './components/Drawer';
import { HeaderLogo } from './components/HeaderLogo';
import { MeStateType, } from 'common/types';
import { hasAccessSelector, isLoggedSelector, } from 'common/selectors';
import { PORTAL_GWO_LINK, } from 'common/constants';

type Props = {
    isLogged: boolean,
};

const Header: React.FC<Props> = ({ isLogged, }) => {
    const appBarClasses = layout.makeAppBarHeaderStyles({ isLogged, });
    const containerClasses = layout.makeContainerHeaderStyles();
    const gridContainerClasses = layout.makeGridContainerHeaderStyles({ isLogged, });
    const { iconContainer, } = layout.makeHeaderStyles();

    const [ isDrawerActive, setDrawerOpenState, ] = useState(false);
    const setDrawerOpenStateWrapper = (state: boolean) => () => setDrawerOpenState(state);

    return (
        <AppBar position="static"
                classes={appBarClasses}
                color="default">
            <Container classes={containerClasses}>
                <Grid container
                      classes={gridContainerClasses}>
                    <Grid item
                          xs={2}
                          md={4}>
                        <Hidden smDown>
                            <Box marginTop={1}>
                                <Link href={PORTAL_GWO_LINK}>
                                    <img src={logo}
                                         height="75"
                                         alt="logo"
                                         loading="lazy" />
                                </Link>
                            </Box>
                        </Hidden>
                        <Hidden mdUp>
                            <div className={iconContainer}
                                 onClick={setDrawerOpenStateWrapper(true)}>
                                <MenuIcon />
                            </div>
                            <Drawer isDrawerActive={isDrawerActive}
                                    setDrawerOpenState={setDrawerOpenStateWrapper} />
                        </Hidden>
                    </Grid>
                    <Grid item
                          xs={8}
                          md={4}>
                        <HeaderLogo />
                    </Grid>
                    <Grid item
                          xs={2}
                          md={4}>
                        <UserPanelContainer />
                    </Grid>
                </Grid>
            </Container>
        </AppBar>
    );
};

const mapStateToProps = (state: MeStateType) => ({
    isLogged: isLoggedSelector(state),
    hasAccess: hasAccessSelector(state),
});

export default connect(mapStateToProps)(Header);
